<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-spin :spinning="spinning">
        <a-form layout="inline" @keyup.enter.native="searchQuery">


          <a-row :gutter="12">
            <a-col :md="6" :sm="8">
              <a-form-item :label="'Type'">
                <a-select default-value="" style="width: 200px" v-model="queryParam.contractType" :allowClear='allowClear'>
                  <a-select-option value="html"> HTMLContract </a-select-option>
                  <a-select-option value="pdf"> PDFContract </a-select-option>
                  <a-select-option value="card_html"> CARD_HTMLContract </a-select-option>
                  <a-select-option value="card_pdf"> CARD_PDFContract </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="12">
              <a-form-item :label="'Order ID separated by commas'" :labelCol="{ span: 12 }" :wrapperCol="{ span: 28, offset: 1 }">
                <a-textarea v-model="queryParam.orderIds" rows="8"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="12">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('search') }}</a-button>
              <a-button type="primary" @click="download" icon="search">Download</a-button>
            </a-col>
          </a-row>
        </a-form>
      </a-spin>

      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        bordered
      >
        <span slot="action" slot-scope="text, record">
          <a @click="genContract(record)">Generate Contract</a>
           <a-divider type="vertical"/>
          <a @click="downloadContract(record)">Download Contract</a>
        </span>
      </a-table>
    </div>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import moment from 'moment'
import { pdfContractQuery,genContract } from '@/webpublicapi/order'
import exportFile from '@/webpublicapi/exportFile'

export default {
  components: {},
  data() {
    return {
      visible: false,
      allowClear: true,
      spinning: false,
      dataSource: [],
      loading: false,
      headers: {
        // authorization: 'authorization-text',
      },
      // Query conditions
      queryParam: {
        contractType: null,
        orderIds: null,
      },
    }
  },
  computed: {
    columns() {
      return [
        {
          title: 'Order ID',
          align: 'left',
          dataIndex: 'orderId',
        },
        {
          title: 'Order No.',
          align: 'left',
          dataIndex: 'orderNo',
        },
        {
          title: 'CustomerID',
          align: 'left',
          dataIndex: 'custId',
        },
        {
          title: 'Order ID',
          align: 'left',
          dataIndex: 'orderId',
        },
        {
          title: 'HTMLContract',
          align: 'left',
          dataIndex: 'contractHtmlPath',
        },
        {
          title: 'PDFContract',
          align: 'left',
          dataIndex: 'contractPdfPath',
        },
        {
          title: 'CARD_HTMLContract',
          align: 'left',
          dataIndex: 'contractCardHtmlPath',
        },
        {
          title: 'CARD_PDFContract',
          align: 'left',
          dataIndex: 'contractCardPdfPath',
        },
        {
          title: 'Action',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 180,
          scopedSlots: { customRender: 'action' }
        }
      ]
    },
  },
  created() {
  },
  methods: {
    getQueryParams() {
      const data = {
        ...this.queryParam,
      }
      return filterObj(data)
    },
    searchQuery() {
      this.loadData()
    },
    download() {
      var params = this.getQueryParams() // Query conditions
      const file = {
        fileUrl: '/api/web/webpublic/contract/pdf/download?orderIds=' + params.orderIds +'&contractType=' + this.checkParam(params.contractType),
        fileName: 'PdfContracts.zip',
      }
      this.loading = true;
      exportFile(file).catch(e => {
        this.$message.error(e.message);
      }).finally(() => {
        this.loading = false;
      })
    },
    downloadContract(record) {
      const file = {
        fileUrl: '/api/web/webpublic/contract/cur/download?orderId=' + record.orderId,
        fileName: 'CurContracts.zip',
      }
      this.loading = true;
      exportFile(file).catch(e => {
        this.$message.error(e.message);
      }).finally(() => {
        this.loading = false;
      })
    },
    checkParam(p){
      if(p===null || p === 'null' || p === undefined || p === 'undefined') {
        return '';
      }
      return p;
    },
    loadData() {
      this.loading = true
      var params = this.getQueryParams() // Query conditions

      pdfContractQuery(Object.assign({}, params))
        .then((res) => {
          if (res.code === 1000) {
            this.dataSource = res.data
          } else {
            this.dataSource = []
            this.$message.error(res.msg)
          }
          this.loading = false
        })
        .catch((e) => {
          this.loading = false
          this.$message.error(e.message)
        })
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    genContract(record) {
      this.loading = true
      var params = {
        orderId: record.orderId,
        custId: record.custId
      }
      genContract(params).then((res) => {
          if (res.code === 1000) {
            this.$message.info(res.msg)
          } else {
            this.$message.error(res.msg)
          }
          this.loading = false
        }).catch((e) => {
          this.loading = false
          this.$message.error(e.message)
        })
    },
  },
}
</script>
<style lang="less" scoped>
@import '~@/assets/less/common.less';
</style>
